<template>
  <div class="sidebar-content sidebar-content--sleeves">
    <h1 class="sidebar-title">Sleeve Color</h1>
    <h3 class="sidebar-subtitle">Pick Sleeves Color</h3>

    <ColorPicker
      :colors="colorsCategories.sleevesColors"
      @onSelectColor="onSelectColor"
    />

    <div class="color-label">Selected Color:</div>
    <b>{{ sleevesColor.title }}</b>
  </div>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker.vue';

export default {
  name: 'SleevesSidebar',
  components: {
    ColorPicker,
  },
  data () {
    return {
      colors: [],
    };
  },

  watch: {
    sleevesColor () {
      if (!this.isChangePocketColor) {
        this.$store.commit('design/setPocketsColor', { color: this.sleevesColor });
      }
    },
  },

  computed: {
    isChangePocketColor () {
      return this.$store.getters['design/getIsChangePocketsColor'];
    },
    sleevesColor () {
      return this.$store.getters['design/getSleevesColor'];
    },
    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
  },

  methods: {
    onSelectColor (color) {
      this.$store.commit('design/setSleevesColor', { color });
    }
  }
};
</script>

<style scoped>
  .color-label {
    margin-top: 10px;
  }

  .description {
    font-size: 18px;
    text-align: left;
    padding: 0 30px 0 30px;
    margin-top: 20px;
    font-style: italic;
  }
</style>
